// Praesentations-Schalter fuer Login + Registrierung (Revision 19, Janik 17.09.2026).
//
// Quelle ist GET /api/auth/ui-config (AUTH_R19_ENABLED auf der API-App) — zur
// Laufzeit, nicht per VITE_-Variable, weil Frontend und API getrennte
// DigitalOcean-Apps sind und ein Rueckschalten ohne Frontend-Build gehen muss.
//
// FAIL-CLOSED in dieselbe Richtung wie der Server: Timeout, Netzfehler, kein
// 2xx, keine JSON-Antwort oder etwas anderes als exakt `true` → klassische
// Optik. Die Content-Type-Pruefung ist noetig: solange die API den Endpunkt
// noch nicht hat, liefert staging 200 text/html (SPA-Catch-all) und production
// 404 — beides darf nie als "an" gelten.
//
// Einmal pro Seitenladen gefragt und als Promise gemerkt: die Entscheidung
// faellt VOR dem ersten Render (main.tsx#bootAuth), damit die Formulare genau
// einmal mit ihrer endgueltigen Optik mounten — Turnstile bindet einmal,
// Attribution wird einmal erfasst, Eingaben gehen nie verloren. Bewusst kein
// localStorage: ein Rueckschalten wirkt beim naechsten Laden.

export type AuthUiConfig = {
  authR19Enabled: boolean;
  source: 'api' | 'fallback' | 'override';
};

const CLASSIC: AuthUiConfig = { authR19Enabled: false, source: 'fallback' };
const TIMEOUT_MS = 2000;

// QA-Override ?authDesign=r19|classic — nur staging + lokal, nie auf
// my.leadscraper.de. So kann Om beide Optiken pruefen, ohne dass jemand den
// Schalter auf der API-App umlegen muss.
const OVERRIDE_HOSTS = new Set(['staging.leadscraper.de', 'localhost', '127.0.0.1']);

let pending: Promise<AuthUiConfig> | null = null;

export function loadAuthUiConfig(): Promise<AuthUiConfig> {
  if (pending) return pending;
  pending = (async (): Promise<AuthUiConfig> => {
    try {
      if (OVERRIDE_HOSTS.has(window.location.hostname)) {
        const o = new URLSearchParams(window.location.search).get('authDesign');
        if (o === 'r19' || o === 'classic') {
          return { authR19Enabled: o === 'r19', source: 'override' };
        }
      }
      const res = await fetch('/api/auth/ui-config', {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: AbortSignal.timeout(TIMEOUT_MS),
      });
      if (!res.ok) return CLASSIC;
      if (!(res.headers.get('content-type') ?? '').includes('application/json')) return CLASSIC;
      const body: unknown = await res.json();
      const on =
        typeof body === 'object' &&
        body !== null &&
        (body as { authR19Enabled?: unknown }).authR19Enabled === true;
      return { authR19Enabled: on, source: 'api' };
    } catch {
      return CLASSIC;
    }
  })();
  return pending;
}
